'use strict';

const braintreeVenmoModelBuilder = require('../braintreesdk/braintreeVenmoModelBuilder');
const loaderInstance = require('../../loaderHelper');

const venmoLoaderEl = document.querySelector('.js-braintree-venmo-loader');

/**
 * A class represents Venmo button's base functionality
 */
class VenmoBase {
    constructor() {
        this.venmoModelInstance = braintreeVenmoModelBuilder.init();
        this.buttonSelector = `.js-braintree-${this.venmoModelInstance.configs.pageFlow}-venmo-button`;
        this.button = document.querySelector(this.buttonSelector);
        this.configs = this.venmoModelInstance.configs;
        this.loader = loaderInstance(venmoLoaderEl);
        this.isAccountPage = this.configs.pageFlow === window.braintreeConstants.PAGE_FLOW_ACCOUNT;
    }

    /**
     * Base validation
     * @returns {Object} A validation object result
     */
    validation() {
        const response = {
            error: false,
            messages: ''
        };

        try {
            const isBraintreeVenmoConfigValid = typeof this.configs !== 'object' || this.configs !== null;

            if (!isBraintreeVenmoConfigValid) {
                response.error = true;
                response.messages = this.configs.messages.VENMO_CONFIG_NOT_VALID;
            }
        } catch (error) {
            response.error = true;
            response.messages = error;
        }

        return response;
    }

    /**
     * Initiates general on Venmo button click functionality
     * @returns {void|undefined} Undefined or void
     */
    async onClick() {
        const venmoHelper = require('../helpers/venmoHelper');

        if (!this.isAccountPage) {
            const requestHelper = require('../../paypal/helpers/payPalRequestsHelperGlobal');

            this.basketData = await requestHelper.getBasketData(this.configs.getOrderInfoUrl);
        }

        if (!this.isAccountPage && venmoHelper.checkZeroAmount(this.basketData?.amount, this.configs.messages)) {
            return undefined;
        }

        this.loader.show();

        return this.venmoModelInstance.btVenmoModel.tokenize.call(this);
    }

    /**
     * Initiates a Venmo button functionality
     * @return {void|undefined} Undefined or void
     */
    async initButton() {
        const venmoHelper = require('../helpers/venmoHelper');
        const VenmoAlertHandlerModel = require('../alertHandler/venmoAlertHandlerModel');
        const alertHandler = new VenmoAlertHandlerModel();

        const generalValidation = this.validation();

        if (generalValidation.error && generalValidation.messages.length) {
            alertHandler.showError(generalValidation.messages);

            return undefined;
        }

        const isBrowserSupported = await this.venmoModelInstance.btVenmoModel.isBrowserSupported();

        if (!isBrowserSupported) {
            alertHandler.handleNoBrowserSupportError(this.configs);

            return undefined;
        }

        const isCustomerRegistered = this.isAccountPage || this.configs.isBuyerAuthenticated;
        const fraudData = await this.venmoModelInstance.btVenmoModel.collectFraudData();

        this.venmoInstance = await this.venmoModelInstance.btVenmoModel.createVenmoInstance(isCustomerRegistered);

        venmoHelper.setVenmoDeviceData(fraudData.deviceData);

        document.querySelectorAll(this.buttonSelector).forEach((buttonEl, index) => {
            const isParentRemoveProductModal = Boolean(document.querySelector(this.buttonSelector)?.closest('#removeProductModal'));

            // Due to SFRA bug there is case when global cart buttons template is rendered twice
            // As a result button containers appear in two modals: product quick view modal and product remove modal
            // To avoid unnecessary render of the Venmo button, the duplicate element is deleted
            if (isParentRemoveProductModal) {
                buttonEl.remove();

                return;
            }

            const selector = `${this.buttonSelector}-${index}`;

            buttonEl.classList.add(selector.slice(1));

            window.paypalVenmo.Buttons({
                onInit: (_, actions) => actions.disable(),
                onClick: () => this.onClick(selector),
                fundingSource: window.paypalVenmo.FUNDING.VENMO,
                style: this.configs.style
            })
                .render(selector);

        });

        return undefined;
    }
}

module.exports = VenmoBase;
